import { useEffect, useState } from 'react';
import {
  NFTProQueryString,
  ProjectListParams,
  getInscriptionList,
  getNFTProList,
} from '../services/home';
import { InscriptionType } from '../app/MarketPlace/InscriptionList';
import { NFTProType } from '../app/MarketPlace/NFTProList';

interface IProps {
  inscriptioinListParams: ProjectListParams;
  nftProListParams: NFTProQueryString;
}

export const useMarketList = (props: IProps) => {
  const [state, setState] = useState<{
    loading: boolean;
    inscriptionList?: InscriptionType[];
    nftProList?: NFTProType[];
  }>({
    loading: true,
    inscriptionList: [],
    nftProList: [],
  });

  const fetchInscriptionList = async (data?: ProjectListParams) => {
    try {
      const { code, result } = await getInscriptionList(data);
      if (code === 0) {
        const list = result?.list || [];
        const inscriptionData = list?.map((item) => {
          return {
            projectName: item.tick,
            chainName: 'BTC',
            latestPrice: item.curPrice,
            totalVolume: item.totalVolume,
            changePercent: item.changePercent,
            icon: item.icon,
          };
        });

        return inscriptionData;
      }
    } catch (e) {
      console.error(e);
    }
  };

  const fetchNFTProList = async (params: NFTProQueryString) => {
    try {
      const { code, result } = await getNFTProList(params);
      if (code === 0) {
        const list = result || [];
        const nftproData = list?.map((item) => {
          return {
            collectionName: item.name,
            volumn: item.volume,
            changePercent: item.volumeChange,
            floorPrice: item.floorPrice,
            contractAddress: item.contractAddress,
            chainCode: item.chainCode,
            logoUrl: item.logoUrl,
          };
        });

        return nftproData;
      }
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    async function init() {
      const list1 = await fetchInscriptionList(props.inscriptioinListParams);
      const list2 = await fetchNFTProList(props.nftProListParams);
      setState({
        loading: false,
        inscriptionList: list1 || [],
        nftProList: list2 || [],
      });
    }
    init();
  }, []);

  return {
    inscriptionList: state.inscriptionList,
    nftProList: state.nftProList,
  };
};
